import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import PopupSignInUp from "../common/PopupSignInUp";
import SitemapBanner from "./SitemapBanner";
import SitemapBody from "./SitemapBody";
import "./Sitemap.css";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const index = () => {
  return (
    <>
      <Header />
      <MobileMenu />
      <PopupSignInUp />

      <SitemapBanner />
      <SitemapBody />

      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
       <div className="container-fluid px-0">
        {/* <Footer /> */}
        <OtherLinkFooter />
        <NewFooter />
      </div>
     
    </>
  );
};

export default index;
